import { useEffect, useState } from 'react';

/**
 * useClock — a live Date that re-renders the consumer every `intervalMs`
 * (default 1000ms). The first tick is aligned to the next second boundary so
 * the seconds display flips on the second, not on a drifting offset. Cleans up
 * its timers on unmount.
 *
 * @param {number} [intervalMs=1000] tick cadence in milliseconds
 * @returns {Date} the current time, updated each tick
 */
export function useClock(intervalMs = 1000) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let intervalId;
    // Align the first tick to the next boundary, then tick steadily.
    const msToNextTick = intervalMs - (Date.now() % intervalMs);
    const timeoutId = setTimeout(() => {
      setNow(new Date());
      intervalId = setInterval(() => setNow(new Date()), intervalMs);
    }, msToNextTick);

    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, [intervalMs]);

  return now;
}
